import Alert from '@mui/material/Alert';
import { AlertTitle, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useAppSelector } from '@/store/hooks';
import { useDispatch } from 'react-redux';
import { showAlert } from '@/store/reducers/app';
//import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
interface CommonAlertProps {
  severity?: 'success' | 'error';
  children?: string;
}

const CommonAlert: React.FC<CommonAlertProps> = ({ severity, children }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { isAlertOpen } = useAppSelector((state) => state.appReducer);
  useEffect(() => {
    if (isAlertOpen) {
      setTimeout(() => {
        dispatch(
          showAlert({
            isAlertOpen: false,
          })
        );
      }, 2000);
    }
  });
  return (
    <Alert
      severity={severity}
      // style={{ position: "fixed", bottom: 0, width: "100%", zIndex: 9999 }}
      sx={{
        position: 'fixed',
        bottom: '30%',
        left: '45%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        height: '20%',
        zIndex: 9999,
        backgroundColor:
          severity === 'success'
            ? '#00c683' //theme.palette.secondary.main
            : theme.palette.error.main,
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '600px',
      }}
      iconMapping={{
        success: (
          <CheckCircleOutlineIcon fontSize="large" sx={{ color: '#fff' }} />
        ),
      }}
    >
      <AlertTitle sx={{ fontSize: '1.5rem', fontFamily: 'inherit' }}>
        {severity === 'success' ? 'Success' : 'Error'}
      </AlertTitle>
      {children}
    </Alert>
  );
};

export default CommonAlert;
